import { useTranslations } from '@vocab/react';
import {
  HiddenVisually,
  IconWorkExperience,
  TextLinkButton,
} from 'braid-design-system';
import React from 'react';
import { useDispatch } from 'react-redux';

import { yearsOfExperienceEditClicked } from 'src/modules/analytics/yearsOfExperience/actionCreators';
import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import { GetYearsOfExperienceDocument } from 'src/types/graphql';

import translations from './.vocab';

export const YearsOfExperienceSubTitle = ({
  openYearsOfExperienceDialog,
}: {
  openYearsOfExperienceDialog: () => void;
}) => {
  const { t } = useTranslations(translations);
  const { language } = useAppConfig();
  const dispatch = useDispatch();

  const { data, loading, error } = useQuery(GetYearsOfExperienceDocument, {
    variables: { languageCode: language },
  });

  const yearsOfExperience =
    loading || error ? null : data?.viewer?.yearsOfExperience;

  const { option, newToWorkforce } = yearsOfExperience ?? {};

  if (newToWorkforce) {
    return (
      <>
        <IconWorkExperience /> {t('New to workforce')}
      </>
    );
  }

  if (option?.id) {
    return (
      <>
        <IconWorkExperience /> {option?.description} {t('of experience')}{' '}
        <TextLinkButton
          onClick={() => {
            openYearsOfExperienceDialog();
            dispatch(
              yearsOfExperienceEditClicked({
                currentPageSectionState: 'edit',
              }),
            );
          }}
          data={{ automation: `years-of-experience-edit` }}
          hitArea="large"
        >
          {t('Edit years of experience', {
            HiddenVisually: (v) => <HiddenVisually>{v}</HiddenVisually>,
          })}
        </TextLinkButton>
      </>
    );
  }

  return (
    <>
      <IconWorkExperience /> {t('Not specified')}
    </>
  );
};
